module.exports = __webpack_public_path__ + "static/media/file-code.b27d3ab0.svg";